<template>
  <div class="select-households">
    <el-dialog
      :title="$t('OrderFood.SelectHousehold')"
      :visible.sync="isVisible"
      @close="handleClose"
    >
      <div class="subtitle">
        {{ $t('OrderFood.MultipleHouseholdDetected') }}
      </div>
      <el-table
        :data="householdArr"
        :empty-text="$t('OrderFood.TempNoHousehold')"
        border
        height="100%"
        style="width: 100%"
        :row-class-name="getRowClassName"
        @row-click="selectHousehold"
      >
        <el-table-column
          align="center"
          :label="$t('OrderFood.Select')"
          width="80"
        >
          <template slot-scope="scope">
            <el-checkbox
              :value="scope.row.tabletId === selectedTabletId"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="tabletNote"
          :label="$t('OrderFood.Household')"
          align="center"
        />
      </el-table>
      <div class="button-container">
        <el-button @click="handleCancel">
          {{ $t('General.Cancel') }}
        </el-button>
        <el-button
          type="primary"
          :disabled="!isSubmittable"
          @click="isVisible = false"
        >
          {{ $t('General.Submit') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

  <script>
export default {
  name: 'SelectHouseholds',
  props: {
    householdArr: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isVisible: false, // 是否顯示對話框
      selectedHousehold: null // 選擇的戶別
    }
  },
  computed: {
    isSubmittable () {
      return !!this.selectedHousehold
    },
    selectedTabletId () {
      return this.selectedHousehold?.tabletId
    }
  },
  watch: {
    householdArr (data) {
      if (data.length) {
        this.isVisible = true
      }
    }
  },
  methods: {
    /**
     * 選擇戶別
     * @param {object} row 資料列物件
     */
    selectHousehold (row) {
      this.selectedHousehold = row
    },
    // 處理取消
    handleCancel () {
      this.selectedHousehold = null
      this.isVisible = false
    },
    // 處理關閉對話框
    handleClose () {
      // 只有在有選擇戶別時才觸發 emit
      if (this.selectedHousehold) {
        this.$emit('selectHousehold', this.selectedHousehold)
      }
      this.selectedHousehold = null
      this.isVisible = false
    },
    // 取得列樣式
    getRowClassName ({ row }) {
      const classArr = ['clickable-row']
      if (row.tabletId === this.selectedTabletId) {
        classArr.push('active')
      }
      return classArr.join(' ')
    }
  }
}
  </script>

  <style lang="scss" scoped>
  .select-households {
    ::v-deep .el-dialog {
      @include basicDialog();
      .el-table {
        @include basicTable();
      }
      .el-dialog__body {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 20px;
        .clickable-row {
          cursor: pointer;
        }
        .active {
          background-color: $defaultColorActive;
        }
        .button-container {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  </style>
